import * as React from "react";
import Title from "../../app/components/Title";
import { Box, Stack, TextField } from "@mui/material";
import RadioButtonGroup from "../../app/components/RadioButtonGroup";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";

import {
  DesktopDatePicker,
  LoadingButton,
  LocalizationProvider,
} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  addMonths,
  formatDateForQueryParam,
  getMinMaxDateForFilter,
} from "../../app/util/dateHelper";
import {
  entrezDbSelectors,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";
import { DateFilter } from "../../app/models/db";
import { entrezConfig } from "../../app/util/entrezConfig";
import { queryTermFormatter } from "../../app/util/util";
import { useEffect } from "react";

const publicationDateOptions = [
  { value: "0", label: "6 months" },
  { value: "1", label: "12 months" },
  { value: "2", label: "5 years" },
  { value: "99", label: "All years" },
  { value: "100", label: "Custom range.." },
];

interface Props {}

export default function Filters(props: Props) {
  const [dateOption, setDateOption] = React.useState(-1);

  const { dbParams, status } = useAppSelector((state) => state.entrezDb); //access the state value

  const dispatch = useAppDispatch();

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  //const qFields =selectedDbWithItsState?.queryFields;

  var dateMinMax = getMinMaxDateForFilter(100); //to get default min max dates

  useEffect(() => {
    console.log("useEffect of filters");
    if (
      selectedDbWithItsState?.queryFields &&
      selectedDbWithItsState?.queryFields.length >= 0
    ) {
      var isPDATFound = false;
      for (var i = 0; i < selectedDbWithItsState!.queryFields.length; i++) {
        if (selectedDbWithItsState!.queryFields[i].field === "PDAT") {
          isPDATFound = true;
          break;
        }
      }

      if (!isPDATFound) {
        setDateOption(-1);
      }
    }
  }, [selectedDbWithItsState!.queryFields]);

  const handleDateOptionSelection = (event: any) => {
    setDateOption(+event.target.value);
    console.log(event.target.value);

    if (event.target.value === "100") return; //on custom range, react to apply button click

    console.log("date handle selection from filter control");

    dateMinMax = getMinMaxDateForFilter(+event.target.value);

    var updatedDate = {
      mindate: dateMinMax.mindate,
      maxdate: dateMinMax.maxdate,
      isApplied: true,
    };

    addToQueryTerms(updatedDate);
    //updateDateFilterAndDispatch(updatedDate);
  };

  function addToQueryTerms(minmaxDate: DateFilter) {
    const formattedDate = minmaxDate.mindate + "[PDAT] : " + minmaxDate.maxdate + "[PDAT]";

    var queryLineItem = {
      term: formattedDate,
      op: entrezConfig.Operators[0],
      field: "PDAT",
    };

    var queries = selectedDbWithItsState!.queryFields;

    queries = [
      ...queries.filter((q) => q.field !== queryLineItem.field),
      queryLineItem,
    ];

    const formattedQueryTerm = queryTermFormatter(queries);
    //{ id: 'a', changes: { title: 'First (altered)' } }
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          queryFields: queries,
          finalFormattedSearchTerm: formattedQueryTerm,
        },
      })
    );
  }

  const [startDate, setStartDateValue] = React.useState<Date | null>(
    new Date()
  );

  const handleChangeStartDate = (newValue: Date | null) => {
    setStartDateValue(newValue);
  };

  const [endDate, setEndDateValue] = React.useState<Date | null>(new Date());

  const handleChangeEndDate = (newValue: Date | null) => {
    setEndDateValue(newValue);
  };

  const handleCustomOnApply = () => {
    var updatedDate = {
      mindate: formatDateForQueryParam(startDate!),
      maxdate: formatDateForQueryParam(endDate!),
      isApplied: true,
    };

    addToQueryTerms(updatedDate);
  };
  return (
    <Box display="flex" flexDirection="column" alignItems="left">
      <Title>Publication Date</Title>
      <RadioButtonGroup
        selectedValue={dateOption.toString()}
        options={publicationDateOptions}
        onChange={handleDateOptionSelection}
      ></RadioButtonGroup>

      {dateOption === 100 && (
        <Box display="flex" flexDirection="column" alignItems="center">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack sx={{ mt: 2 }} component="form" noValidate spacing={2}>
              <DesktopDatePicker
                label="Start Date"
                inputFormat="MM/dd/yyyy"
                value={startDate}
                onChange={handleChangeStartDate}
                renderInput={(params) => <TextField {...params} />}
              />
              <DesktopDatePicker
                label="End Date"
                inputFormat="MM/dd/yyyy"
                value={endDate}
                onChange={handleChangeEndDate}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>

            <LoadingButton
              onClick={handleCustomOnApply}
              sx={{ mt: 1 }}
              size="small"
              variant="contained"
               // loading={status.includes("pendingEFetchSearchResults")}
            >
              Apply date
            </LoadingButton>
          </LocalizationProvider>
        </Box>
      )}
    </Box>
  );
}